<div class="row mt-2 mb-2 border">
  <div class="col">
    <div class="row no-gutters bg-light">
      <div class="col-sm-8 col-7 p-2">
        Journey Detail
      </div>
      <div class="col-sm-4 col-5 p-2">
        <small><i class="fas fa-times pointer ml-2 text-secondary pull-right" (click)="closeClicked()"
            data-toggle="tooltip" data-placement="right" title="Close"></i></small>
      </div>
    </div>

    <div *ngIf="journeyDetail">
      <div class="row" style="text-align:centre;margin: 10px; margin-left:30px;margin-top: 30px;">
        <img src="assets/images/journey/car.png" alt="Car" style="max-height:100px;">
        <h6 style=" text-align:left;margin-left: 30px;"> {{vehicle.make}} {{vehicle.model}} - Model Year
          {{vehicle.year}}
          <br> {{vehicle.vin}} </h6>
      </div>
      <div class="scroll-view">
        <div class="row">
          <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <!-- <th scope="col" width="14%" class="text-left"></th>
                <th scope="col" width="14%" class="text-left">Start Location</th>
                <th scope="col" width="12%" class="text-left">End Location</th>
                <th scope="col" width="12%" class="text-left">Distance Travelled(miles)</th>
                <th scope="col" width="12%" class="text-left">Duration(mins)</th>
                <th scope="col" width="12%" class="text-left">RPM Exceed 4K</th>
                <th scope="col" width="12%" class="text-left">RPM Exceed 6K</th>
                <th scope="col" width="12%" class="text-left">Engine Warmup Time</th> -->

              </tr>
            </thead>
            <tbody>
              <tr>
                <td  class="pointer text-left">
                  <span>Start Date: </span>{{journeyDetail.startDate| date:'MM/dd/yyyy hh:mm'}}
                </td>
                <td  class="pointer text-left">
                  <span>End Date: </span>{{journeyDetail.endDate| date:'MM/dd/yyyy hh:mm'}}
                </td>
                <td></td>
              </tr>
              <tr>
                <td class="pointer text-left">
                  <span>Start Location: </span>
                  <span>{{journeyDetail.startLocation.coordinate.latitude | number:'1.4-4'}}&deg;</span>,&nbsp;&nbsp;
                  <span>{{journeyDetail.startLocation.coordinate.longitude| number:'1.4-4'}}&deg;</span>
                </td>
                <td class="pointer text-left">
                  <span>End Location: </span>
                  <span>{{journeyDetail.endLocation.coordinate.latitude | number:'1.4-4'}}&deg;</span>,&nbsp;&nbsp;
                  <span>{{journeyDetail.endLocation.coordinate.longitude | number:'1.4-4'}}&deg;</span>
                </td>
                <td></td>
              </tr>
              <tr>
                <td class="pointer text-left">
                  <span>Distance Travelled: </span>
                  <span>{{journeyDetail.distanceTravel.value | number:'1.2-2'}} mi</span>
                </td>
                <td class="pointer text-left">
                  <span>Duration: </span>
                  <span *ngIf="(journeyDetail.duration && journeyDetail.duration < 60); else inHours;">
                      <span *ngIf="(journeyDetail.duration >= 10); else inMins;">
                          0:{{journeyDetail.duration}}
                      </span>
                      <ng-template #inMins>
                          0:0{{journeyDetail.duration}}
                      </ng-template>
                      hrs
                  </span> 
                  <ng-template #inHours>{{(journeyDetail.duration/60)| intNumber}}:{{(journeyDetail.duration%60).toFixed(0)}} hrs</ng-template>
                </td>
                <td></td>
              </tr>
              <tr>
                <td class="pointer text-left">
                    <span>RPM Exceeds 4K: </span>
                  <span>{{journeyDetail.rpmExceed4K}}</span>
                </td>
                <td class="pointer text-left">
                    <span>RPM Exceeds 6K: </span>
                  <span>{{journeyDetail.rpmExceed6K}}</span>
                </td>
                <td class="pointer text-left">
                    <span>Engine WarmUp Time: </span>
                  <span>{{journeyDetail.engineWarmupTime}} sec</span>
                </td>
              </tr>
            
          
          
            <!-- Trip Details Info -->
            <tr>
              <td colspan="3">

              <div class="row pt-2 ml-1">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4" style="text-align:center">
                  <img class="img-fluid icon" src="assets/images/journey/speed.png" alt="Avg Speed"> <br>
                  <span style="font-size: 10px;"> Avg Speed </span> <br> {{journeyDetail.avgSpeed | number:'1.2-2'}} mi/hr
                </div>

                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4" style="text-align:center">
                  <img class="img-fluid icon" src="assets/images/journey/pump.png" alt="Fuel Consumption"> <br>
                  <span style="font-size: 10px;"> Fuel Consumption </span> <br>
                  {{journeyDetail.fuelConsumption.value| number:'1.2-2'}} gal
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4" style="text-align:center">
                  <img class="img-fluid icon" src="assets/images/journey/pressure.png" alt="Tire Pressure"> <br>
                  <span style="font-size: 10px;"> Tire Pressure (psi) </span> <br>
                  <span *ngIf="journeyDetail.tyrePressure">
                    {{journeyDetail.tyrePressure.frontLeft.value}} &nbsp;
                    {{journeyDetail.tyrePressure.frontRight.value}} &nbsp;
                    {{journeyDetail.tyrePressure.rearLeft.value}} &nbsp;
                    {{journeyDetail.tyrePressure.rearRight.value}} &nbsp;
                  </span>
                </div>
              </div>
            </td>
            </tr>
            </tbody>
          </table>
          </div>
          <!-- Trip details end -->
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
            <!-- Add Google map here -->
            <div class="gmap" id="map" #gmap>.</div>
            <!-- <div #gmap style="width:100%;height:300px"></div> -->
          </div>
        </div>



      </div>
    </div>
  </div>
</div>